export const MOCK_ACCOUNT_USERS = {
  data: [
    {
      _id: '42c6e2af-145a-416d-b766-62b1fc2b0ffa',
      _schema: 'portal_user',
      first_name: 'John',
      last_name: 'Doe',
      email: 'john.doe@example.com',
      registration_status: 'Registered',
      access_status: true,
      has_portal_user: true
    },
    {
      _id: 'a1b2c3d4-e5f6-7890-abcd-ef1234567890',
      _schema: 'portal_user',
      first_name: 'Jane',
      last_name: 'Smith',
      email: 'jane.smith@example.com',
      registration_status: 'Registered',
      access_status: true,
      has_portal_user: true
    },
    {
      _id: 'b2c3d4e5-f6a7-8901-bcde-f12345678901',
      _schema: 'portal_user',
      first_name: '',
      last_name: '',
      email: 'pending.user@example.com',
      registration_status: 'Pending',
      access_status: true,
      has_portal_user: true
    },
    {
      _id: 'c3d4e5f6-a7b8-9012-cdef-123456789012',
      _schema: 'portal_user',
      first_name: 'Max',
      last_name: 'Mustermann',
      email: 'max.mustermann@example.com',
      registration_status: 'Registered',
      access_status: false,
      has_portal_user: true
    }
  ]
}
